import { get } from '../../shared/helpers/axiosInstance';
import { PostalCodeResponse } from '../types/zipcode.type';

export const fetchByPostalCode = async (cp: string) =>
	get<PostalCodeResponse[]>(`/v1/zipcode/${cp}`);
